import { useEffect } from "react";

import { useAppStore } from "../store";

/**
 * Component that listens for the "d" key press and toggles debug mode
 * This component doesn't render anything visible and should be mounted once at the app root
 */
const DebugModeListener = () => {
  const toggleDebugMode = useAppStore((state) => state.toggleDebugMode);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Toggle debug mode when 'd' key is pressed
      // Skip if the key is pressed while any input element is focused
      if (
        ["INPUT", "TEXTAREA", "SELECT"].includes((document.activeElement?.tagName || "").toUpperCase()) ||
        (document.activeElement as HTMLElement)?.isContentEditable
      ) {
        return;
      }

      // Check if 'd' key is pressed (case insensitive)
      if (event.key.toLowerCase() === "d") {
        toggleDebugMode();
        console.log("Debug mode toggled");
      }
    };

    // Add event listener
    window.addEventListener("keydown", handleKeyDown);

    // Clean up
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggleDebugMode]);

  // This component doesn't render anything
  return null;
};

export default DebugModeListener;
